<template>
    <div>
        <section class="mbr-section mbr-parallax-background" id="content5-i" data-rv-view="17"
                 style="background-image: url(assets/images/fazenda-732x543.jpg); padding-top: 120px; padding-bottom: 120px;">

            <div class="mbr-overlay" style="opacity: 0.7; background-color: rgb(0, 0, 0);">
            </div>

            <div class="container">
                <h3 class="mbr-section-title display-2">{{ data.title }}</h3>
                <div class="lead">
                    <p>
                      {{data.content}}
                </p>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  },
  data() {
    return {
      language: {},
      data: '',
      pt: {
        title: 'Comprometimento',
        content: 'Mudanças no mercado de grãos, principalmente na forma de comercialização, como a rejeição aos transgênicos e o consequente aumento da demanda por grãos convencionais, tanto no mercado interno quanto externo, motivaram a BRMill alimentos a produzir e comercializar ingredientes de milho convencional (GMO Free). Atualmente, os principais elementos que definem a competitividade dos ingredientes de milho no processo de comercialização interna e de exportação, são os teores de umidade, níveis de micotoxina (como a fumonisina) e a transgenia. Com isso, é evidente que há uma preocupação e preferência do mercado pelo milho GMO Free. Com essa crescente demanda, a empresa se especializou em processar apenas milho convencional ou orgânico, cumprindo com criteriosos processos de produção. A localização privilegiada em que se encontram as instalações da BRMill Alimentos permite que se tenha controle desde a seleção de sementes, feita pelos produtores parceiros, bem como orientações dadas a eles sobre cuidados no cultivo, colheita e transporte de forma segura, evitando assim as chances de contaminação cruzada. No recebimento dos grãos, estes passam por rigorosas análises que avaliam os fatores acima citados (micotoxinas, umidade e transgenia) e, apenas após essa avaliação, os grãos seguirão para o processo de degerminação e moagem. Desta maneira, a BRMill Alimentos pretende sempre garantir a qualidade e segurança de um produto em crescente demanda e que exige um cuidado específico de acordo com as preferências de consumo atuais.'
      },
      en: {
        title: 'Commitment',
        content: 'Changes in the grain consumer market, such as the rejection of transgenics ingredients in food products, consequently increase the demand for conventional grains, both in the domestic and foreign markets, motivating BRMill Alimentos to produce and commercialize conventional corn ingredients (GMO Free).\n' +
            'Currently the main elements that defines the competitiveness of corn ingredients are  its moisture content, mycotoxin levels (such as fumonisin) and GMO’s. By this, it is clear that there is a concern and market preference for GMO Free corn. \n' +
            'With this growing demand, the company specialized in processing only conventional corn, complying with strict production processes. \n' +
            'The privileged location where BRMill Alimentos facilities are located allows extensive control since the selection of the seeds that will be grown by our farmers, up to the harvest and deliver of the raw material in its facilities avoiding any chances of cross contamination. When the grains are received, they undergo rigorous analyzes that assess the factors mentioned above (mycotoxins, humidity and transgenics) and only after this evaluation is completed and approved that the grains are allowed to enter the facility for the degermination and milling process. In this way, BRMill Alimentos always intends to guarantee the quality and safety of a product in accordance with the current consumption preferences.\n'
      },
      es: {
        title: 'Compromiso',
        content: 'Los cambios en el mercado de granos, principalmente en la forma de comercialización, como el rechazo de los ingredientes transgénicos y el aumento de la demanda de granos convencionales en el mercado interno y externo, motivaron la BRMill Alimentos a producir y comercializar ingredientes a base de maíz convencional (No GMO). Actualmente, los principales elementos que definen la competitividad de los ingredientes de maíz en el proceso de comercialización nacional y de exportación son el contenido de humedad, los niveles de micotoxinas (como las fumonisinas) y los transgénicos. Con esto, eres evidente que existe una preocupación y preferencia del mercado por el maíz libre de transgénicos. Con esta creciente demanda, la empresa se especializó en procesar únicamente maíz convencional, cumpliendo con estrictos procesos productivos. \n' +
            'La ubicación privilegiada en que se encuentran las instalaciones de BRMill Alimentos permite el control desde la selección de semillas de los productores locales, así como las orientaciones sobre los cuidados en el cultivo, cosecha y transporte de forma segura, evitando así las posibilidades de contaminación cruzada. \n' +
            'En el recibimiento de la materia prima los granos son sometidos a un control estricto de análisis que evalúan los factores mencionados anteriormente (micotoxinas, humedad y transgénicos) y solo después de esta evaluación que los granos son liberados para la desgerminación y molienda. De esta forma, BRMill Alimentos garantiza la calidad y seguridad de un producto cada vez más demandado que requiere cuidados específicos de acuerdo con las preferencias de consumo actuales.\n'
      }
    }
  },
  methods: {
    setLanguage: function (value) {
      this.language = value
      localStorage.setItem('language', value)
      document.location.reload(true);
    }

  },
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt')
      document.location.reload(true);
    }
    switch (this.language) {
      case 'en':
        this.data = this.en;
        break;
      case 'es':
        this.data = this.es;
        break;
      default:
        this.data = this.pt;
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .hero {
        padding-top: 7rem;
        width: 100%;
        height: 500px;
        text-align: left;
    }

</style>
